<template>
  <section class="py-8 mx-6">
    <div class="flex flex-col gap-8">
      <div class="title text-center text-2xl font-bold text-base-color">
        Find The Perfect <span class="block">Property</span>
      </div>
      <div class="image">
        <img class="rounded-2xl" src="/images/splash.jpg" />
      </div>
      <div class="about text-center text-lg text-gray-400">
        Wujudkan properti impian anda dengan PropertiKu secara mudah dan panduan
        ahli real estate dalam genggaman anda.
      </div>
      <div class="flex flex-row justify-end items-center">
        <router-link to="/home">
          <Button title="Start" />
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
import Button from "../components/Button.vue";
export default {
  name: "Splashscreen",
  components: { Button },
};
</script>
